import React from 'react';
import { SkipNav } from '@ver-uds/uswds-react';
import { PageHeader } from '@ver-uds/react';
import ErrorType from './ErrorType';
import EvePageNotFoundError from './EvePageNotFoundError';
import EveGeneralError from './EveGeneralError';

export interface EveGeneralErrorProps {
  errorType: ErrorType.GENERAL;
  product: string;
  contact: string;
}

export interface EvePageNotFoundErrorProps {
  errorType: ErrorType.NOT_FOUND;
}

export type EveErrorProps = EveGeneralErrorProps | EvePageNotFoundErrorProps;

const EveError = (props: EveErrorProps): JSX.Element => {
  const { errorType } = props;

  function generateEveError(): JSX.Element | null {
    switch (props.errorType) {
      case ErrorType.GENERAL: {
        const { product, contact } = props;
        return <EveGeneralError product={product} contact={contact} />;
      }
      case ErrorType.NOT_FOUND:
        return <EvePageNotFoundError />;
      default:
        return null;
    }
  }

  return (
    <>
      <PageHeader variant="error">{errorType}</PageHeader>
      <SkipNav.MainContent>
        <section className="grid-container usa-section padding-top-4">{generateEveError()}</section>
      </SkipNav.MainContent>
    </>
  );
};

export default EveError;
